import React, { useState, useEffect, Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
    gettheStoretheRejoiningActions
} from "../../../Redux/Slice";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import Button from "@mui/material/Button";
import PlusIcon from "../../../Assets/AppComponent/Asset 9.svg"
import minus from "../../../Assets/AppComponent/Asset 10.svg"
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";
import { toast } from "react-toastify";

const Rejections = () => {

    const state = useSelector((state) => state)
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive);
    const [nameList4, setOptions4] = useState([]);
    const [searchBranch, setSearch] = useState("");
    const dispatch = useDispatch();
    const [ClientValues, setclientValues] = useState()
    const [RoleOPtions, setRoleOPtions] = useState();
    const [rolesearch, setrolesearch] = useState("");
    const [roleValues, setRoleValues] = useState();
    const [Onboarderoptions, setonboarderoptions] = useState();
    const [OnboarderValues, setonboarderValue] = useState()
    const [remarkserror, setremarkserr] = useState("");
    const [inputFields, setInputFields] = useState([
        {
            Files: "",
            file: "",
        },
    ]);
    const [PresentUrls, setPresentUrls] = useState([])
    const [url, setUrl] = useState();
    const [alert, setalert] = useState(false);
    const [CroppImageView, setCroppImageView] = useState(false);
    const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
    const [images, setImages] = useState([]);
    const [forindex, setforindex] = useState();
    const [updated, setupdatefile] = useState(false);
    const [imagesFile, setImagesFile] = useState([]);
    const [imageFileChange, setImageFileChange] = useState([
        false,
        false,
        false,
        false,
    ]);
    const [imageFiles, setImageFiles] = useState();


    const [documentPassed, setdocumentPassed] = useState(false)
    const updateAvatar = (imgSrc) => {
        fileInputRef.current = imgSrc;
    };
    const [imgsrc, setImgsrc] = useState();
    const fileInputRef = useRef();
    const navigate = useNavigate();
    const initialState = {
        user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
        name: state.EmployeeProfile.EmployeeProfileList.user_id.first_name,
        remarks: "",
        rejection_type: "",

    }
    const [data, setdata] = useState(initialState);
    const [remarkserr, steremarkserr] = useState("");
    const rejectionOptions = [
        { value: "0", label: "Bank Details" },
        { value: "1", label: "Aadhar Card" },
        { value: "2", label: "PAN Card" },
        { value: "3", label: "Other Reasons" },
    ];
    
    const [RejectionValues, setrejectionvalue] = useState();
    const [rejctiontypeerr, setrejecterr] = useState("")



    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[index] = "";
            return newImages;
        });
        setInputFields(values);
        const updatedImagesFile = [...imagesFile];

        updatedImagesFile[index] = "";
        setImagesFile(updatedImagesFile);
    };
    const handleAddFields = (index) => {
        if (inputFields.length != 10) {
            const values = [...inputFields];
            values.push({
                Files: "",
                file: "",
            });

            setInputFields(values);
            setImages((prevImages) => {
                const newImages = [...prevImages];
                newImages[index] = "";
                return newImages;
            });
        }
    };

    const handleInputChange = (index, event) => {
        const values = [...inputFields];

        if (event.target.name === "file") {
            setalert(true);
            // images.map((item)=>{
            //   values[index].Files = item;
            // })
            setImageFiles(event)
            //console.log(event.target.files[0], "evefasfsdl");
            setCroppImageViewCount(index);
            setCroppImageView(true);
            setupdatefile(true);



            const file = event.target.files[0];
            const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            const MIN_DIMENSION = 150;

            if (file && allowedTypes.includes(file.type)) {
                if (file.size > maxSize) {
                    setCroppImageView(false);
                    toast.error("File size exceeds 10MB. Please upload a smaller image.");
                } else {
                    const reader = new FileReader();
                    reader.addEventListener("load", () => {
                        const imageElement = new Image();
                        const imageUrl = reader.result?.toString() || "";
                        imageElement.src = imageUrl;

                        imageElement.addEventListener("load", (imgEvent) => {
                            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

                            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                                toast.error("Image must be at least 150 x 150 pixels.");
                                setCroppImageView(false);
                                return;
                            }
                            selectedImage(event, index);
                        });
                    });
                    reader.readAsDataURL(file); // Read the file as a data URL
                }
            } else {
                setCroppImageView(false);
                toast.error("Please upload an image file (jpg, jpeg, png, svg).");
            }
        }

        setInputFields(values);
    };
    function getCroppedImg(imageRef, crop, fileName) {
        const canvas = document.createElement("canvas");
        const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
        const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            imageRef.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );


        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Canvas is empty");
                    return;
                }
                const croppedFile = new File([blob], fileName, {
                    type: "image/jpeg",
                });
                var file = croppedFile;
                if (croppedFile) {
                    setTimeout(() => {
                        setCroppImageView(false)

                    }, 0);
                }
                setImageFileChange((prevState) => {
                    const newState = [...prevState];
                    newState[forindex] = true;
                    return newState;
                });

                const valuesFile = [...inputFields]; ///file
                valuesFile[forindex].file = croppedFile; // Assuming you have a field for croppedImageData
                setInputFields(valuesFile);

                const generateRandomNumber = (digits = 12) => {
  const min = 10 ** (digits - 1);
  const max = 10 ** digits;
  return Math.floor(min + Math.random() * (max - min));
};


                const createPresentData = (croppedFile) => {
                    const randomNumber = generateRandomNumber();
                    const formattedFilename = `onboarding/rejection_support_doc/cropped${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
                    const Presentdata = {
                        multiple_files: [
                            {
                                filename: formattedFilename,
                                file_type: croppedFile.type,
                            },
                        ],
                    };

                    return Presentdata;
                };

                const Presentdata = createPresentData(croppedFile);

                setupdatefile(true);

                axios({
                    url: PresentUrl,
                    method: 'post',
                    data: Presentdata,
                    headers: {
                        Authorization:
                            "Bearer " + store.getState().users.UserData.session.token,
                    },
                })
                    .then((response) => {
                        console.log('Files uploaded successfully:', response.data);
                        const uploadedFiles = response.data.data;

                        const newUrls = uploadedFiles.map(file => ({
                            url: file,
                            type: croppedFile.type,
                            putfiles: croppedFile

                        }));
                        setPresentUrls(prevUrls => {
                            const updatedUrls = [...prevUrls];
                            updatedUrls[forindex] = newUrls[0];
                            return updatedUrls;
                        });



                        const updatedImageUrl = String(response.data.data).split("?")[0]
                        const values = [...inputFields]; ///----result
                        values[forindex].certificate = String(response.data.data).split("?")[0];
                        setInputFields(values);

                        setImagesFile(prevUrls => {
                            const updatedUrls = [...prevUrls];
                            updatedUrls[forindex] = String(response.data.data).split("?")[0];
                            return updatedUrls;
                        });

                    }).catch((error) => {
                        console.error('Error uploading files:', error);
                    });

                setdocumentPassed(true);



                var fileBase = croppedFile;
                var reader = new FileReader();
                reader.onloadend = function () {
                    setImages((prevImages) => {
                        const newImages = [...prevImages];
                        newImages[forindex] = reader.result;
                        return newImages;
                    });
                    const values = [...inputFields];
                    values[forindex].Files = reader.result;
                    setInputFields(values);

                    console.log(inputFields, "inputFields");
                };
                reader.readAsDataURL(fileBase);
                //  }

                blob.name = fileName;
                resolve(croppedFile);
            }, "image/jpeg");
        });
    }
    const handleFiles = (e) => {
        selectedImage(e);
    };
    const selectedImage = (e) => {
        console.log(e.target.files[0], "e.target.files[0]");
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () => setImgsrc(reader.result));
            reader.readAsDataURL(e.target.files[0]);
            console.log(imgsrc, "imgsrc");
        }
    };
    

    const HandleSubmit = () => {
        var a = 0;
        if (data.remarks == "") {
            setremarkserr("*Remarks is requried");
            a = 1;
        }
        if (data.rejection_type == "") {
            a = 1;

            setrejecterr("*Rejection type is requried")
        }
        const fetchUploadFiles = async () => {
            await Promise.all(PresentUrls.map(async (item, index) => {
                try {
                    if (item != undefined && item != null) {

                        const response = await fetch(item.url, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': item.type,
                                "x-amz-acl": "public-read"
                            },
                            body: item.putfiles,
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        if (PresentUrls.length == index + 1) {

                            let EditedDATAPresent = {
                                remarks: data.remarks,
                                user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                                rejection_type: data.rejection_type,

                            }
                            let documentIndex = 0;
                            imagesFile.forEach((element) => {
                                // Check if the element is valid (not null, undefined, or an empty string).
                                if (element !== null && element !== undefined && element !== "") {
                                    EditedDATAPresent[`document${documentIndex}`] = element;
                                    documentIndex++; // Increment the index only for valid elements
                                }
                            });


                            const payload = {
                                formdatas: EditedDATAPresent,
                                API: 1,
                                Funcations: () => {
                                    navigate("/employeeprofile")
                
                                },
                

                            }
                            dispatch(gettheStoretheRejoiningActions(payload))
                            setPresentUrls([]);


                        }

                    }
                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        };

        if (documentPassed == true && a == 0) {
            fetchUploadFiles()

        }
        else if (documentPassed == false && a == 0) {
            const payload = {
                formdatas: {
                    remarks: data.remarks,
                    user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                    rejection_type: data.rejection_type,
                },
                API: 1,
                Funcations: () => {
                    navigate("/employeeprofile")

                },
            }
            dispatch(gettheStoretheRejoiningActions(payload))
        }
    }

    const HandleChanges = (e, valuess) => {
        const { name, value } = e.target;

        setdata({
            ...data,
            [name]: value,
        });
    };
    const HandleREjectionType = (e) => {
        setrejectionvalue(e);
        setdata({
            ...data,
            rejection_type: e.value
        })
    }
    return (
        <>
            <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
                <div className="col BodyContent LeaveEdits">
                    <div className="card">
                        <div className="card-body cards ">
                            <div className="UserPoup">
                                <div className="BeforForms">
                                    <div className="Form">
                                        <div className="ModalHeader">
                                            <span>Rejection</span>
                                            <div
                                                className="CloseIcon"
                                                onClick={(e) => navigate("/employeeprofile")}
                                            >
                                                <CloseOutlinedIcon />
                                            </div>
                                        </div>
                                        <div className="Modal-Body Modal-bodyUserCRUD">
                                            <div className="row">


                                                <div
                                                    className="col-sm-3  mt-3"
                                                >
                                                    <label for="validationCustom01" class="form-label">
                                                        Employee
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        required
                                                        autocomplete="off"
                                                        value={state.EmployeeProfile.EmployeeProfileList.user_id.first_name}
                                                        name="name"
                                                        readOnly
                                                        disabled
                                                    />
                                                </div>

                                                <div
                                                    className="col-sm-3 mt-3"
                                                >
                                                    <label
                                                        for="validationCustom01"
                                                        class="form-label"
                                                        style={{ fontSize: "19px" }}
                                                    >
                                                        Rejection Type
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <Select
                                                        className="Selects"
                                                        styles={{ position: "relative", top: "60px" }}
                                                        onChange={(e) => {
                                                            setrejecterr("");
                                                            HandleREjectionType(e);
                                                        }}
                                                        options={rejectionOptions}
                                                        labelledBy="Select"
                                                        isClearable={true}
                                                        value={ClientValues}

                                                    />
                                                    <p className="Error" style={{ marginLeft: "-5px" }}>{rejctiontypeerr}</p>
                                                </div>

                                                <div
                                                    className="col-sm-3  mt-3"
                                                >
                                                    <label for="validationCustom01" class="form-label">
                                                        Remarks
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        class="form-control"
                                                        required
                                                        autocomplete="off"
                                                        value={data.remarks}
                                                        name="remarks"
                                                        onChange={(e) => {
                                                            HandleChanges(e);
                                                            setremarkserr("");
                                                        }}
                                                    />
                                                    <p className="Error" style={{ marginLeft: "-5px" }}>{remarkserror}</p>
                                                </div>






                                                {/* <div className="col-sm-7 Documentfiled" style={{ marginTop: "62px" }}>
                                                    <label
                                                        for="validationCustom01"
                                                        class="form-label"
                                                        style={{ width: "100%" }}
                                                    >
                                                        Documents
                                                    </label>

                                                    {inputFields.map((inputField, index) => {
                                                        return (
                                                            <Fragment key={`${inputField}~${index}`}>
                                                                <div
                                                                    className="form-group col-sm-12"
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                    }}
                                                                >
                                                                    <div
                                                                        className=" btn  StatusList"
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-end",
                                                                            alignContent: "center",
                                                                            gap: "20px",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className="DeclineStatus"
                                                                            disabled={index === 0}
                                                                            onClick={() => {
                                                                                handleRemoveFields(index);
                                                                            }}
                                                                        >
                                                                            <span>
                                                                                <img src={minus} />
                                                                            </span>                                    </button>

                                                                        <div
                                                                            className="AddingButton"
                                                                            onClick={(index) => {
                                                                                handleAddFields(index);
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: "#F58837",
                                                                                fontSize: "19px",
                                                                                width: "  20px",
                                                                                height: "20px ",
                                                                                borderRadius: "50%",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            <span className="PlusButton">
                                                                                <img src={PlusIcon} />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    className="col-12"
                                                                    style={{ paddingLeft: "25px" }}
                                                                >
                                                                    <label className="mt-3">File Upload</label>


                                                                    <div
                                                                        className="col-12"
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-start",
                                                                            alignItems: "flex-start",
                                                                            gap: "10px",
                                                                            flexDirection: "column",
                                                                        }}
                                                                    >
                                                                        {inputField.Files &&
                                                                            <img
                                                                                // src={images[0]}
                                                                                src={inputField.Files}
                                                                                style={{
                                                                                    width: "150px",
                                                                                    height: "150px",
                                                                                    border: "1px solid #000",
                                                                                    borderRadius: "10px",
                                                                                }}
                                                                            />
                                                                        }

                                                                        <Button
                                                                            className="doctorupload"
                                                                            variant="contained"
                                                                            component="label"
                                                                            style={{
                                                                                background: "#234492",
                                                                                color: "white",
                                                                            }}
                                                                        >

                                                                            <input
                                                                                type="file"
                                                                                hidden
                                                                                accept="image/png, image/jpeg"
                                                                                name="file"
                                                                                // onChange={(e) => handleFiles(e)}
                                                                                onChange={(event) => {
                                                                                    setforindex(index);
                                                                                    handleInputChange(index, event);
                                                                                }}
                                                                                ref={fileInputRef}

                                                                            />
                                                                            Upload Image
                                                                        </Button>
                                                                    </div>

                                                                </div>
                                                            </Fragment>
                                                        );
                                                    })}
                                                </div> */}

<div className="col-sm-12 Documentfiled">
                  <div style={{ display: "flex" }}>

                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "100%" }}
                    >
                      Documents
                    </label>
                  </div>

                  <div style={{ display: "flex" }}>
                    {inputFields.map((inputField, index) => {
                      return (
                        <Fragment key={`${inputField}~${index}`}>
                          <div
                            className="form-group "
                            style={{
                              display: "flex",
                            }}
                          >
                            <div
                              className=" btn  StatusList"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                gap: "20px",
                              }}
                            >

                              <div
                                className="col-sm-7"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                  flexDirection: "column",
                                }}
                              >
                                {inputField.Files &&
                                  <img
                                    // src={images[0]}
                                    src={inputField.Files}
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      border: "1px solid #000",
                                      borderRadius: "10px",
                                    }}
                                  />
                                }

                                <Button
                                  className="doctorupload"
                                  variant="contained"
                                  component="label"
                                  style={{
                                    background: "#234492", color: "#fff",
                                    fontSize: "11px !important"
                                  }}
                                >

                                  <input
                                    type="file"
                                    hidden
                                    accept="image/png, image/jpeg"
                                    name="file"
                                    // onChange={(e) => handleFiles(e)}
                                    onChange={(event) => {
                                      setforindex(index);
                                      handleInputChange(index, event);
                                    }}
                                    ref={fileInputRef}

                                  />
                                  Upload Image
                                </Button>
                              </div>

                              <div className="col" style={{ display: "flex", gap: "19px" }}>

                                <>
                                  <button
                                    className="DeclineStatus"
                                    disabled={index === 0}
                                    onClick={() => {
                                      handleRemoveFields(index);
                                    }}
                                  >
                                    <span>
                                      <img src={minus} />
                                    </span>
                                  </button>
                                  {index === 0 ?
                                   
                                    <div
                                      className="AddingButton"
                                      onClick={() => {
                                        if (inputFields.length < 5) {
                                          handleAddFields(index);
                                        }
                                      }}
                                      style={{
                                        backgroundColor: "#F58837",
                                        fontSize: "19px",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: inputFields.length >= 5 ? "not-allowed" : "pointer",
                                      }}
                                    >
                                      <span className="PlusButton">
                                        <img src={PlusIcon} alt="Add" />
                                      </span>
                                    </div>

                                    : null}

                                </>

                              </div>


                            </div>
                          </div>


                        </Fragment>
                      );
                    })}
                  </div>
                </div>

                                                <div
                                                    className="col-12 mt-5 RejoinSCSS"
                                                    style={{ marginTop: "20px" }}
                                                >
                                                    <div>


                                                        <button
                                                            class="btn ButtonCSS"
                                                            style={{ background: "#234492b0" }}
                                                            onClick={(e) => navigate("/employeeprofile")}

                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            class="btn  ButtonCSS"
                                                            type="submit"
                                                            style={{ background: "#234492" }}
                                                            onClick={(e) => {
                                                                HandleSubmit(e)
                                                            }}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {CroppImageView && (
                <ImageCropper
                    updateAvatar={updateAvatar}
                    selectedImage={imageFiles}
                    getCroppedImg={getCroppedImg}
                    closeModal={() => setCroppImageView(false)}
                />
            )}
        </>
    )
}

export default Rejections